import favicon from "favicon.js";

export function loadFavicon() {
  favicon.animate([
    "images/load/frame_0.png",
    "images/load/frame_1.png",
    "images/load/frame_2.png",
    "images/load/frame_3.png",
    "images/load/frame_4.png",
    "images/load/frame_5.png",
    "images/load/frame_6.png",
    "images/load/frame_7.png",
    "images/load/frame_8.png",
    "images/load/frame_9.png",
    "images/load/frame_10.png",
    "images/load/frame_11.png",
    "images/load/frame_12.png",
    "images/load/frame_13.png",
    "images/load/frame_14.png",
    "images/load/frame_15.png",
    "images/load/frame_16.png",
    "images/load/frame_17.png",
    "images/load/frame_18.png",
    "images/load/frame_19.png",
    "images/load/frame_20.png",
    "images/load/frame_21.png",
    "images/load/frame_22.png",
    "images/load/frame_23.png",
    "images/load/frame_24.png",
    "images/load/frame_25.png",
    "images/load/frame_26.png",
    "images/load/frame_27.png",
  ], 50);
}

export function resetFavicon() {
  favicon.stopAnimate();
  let link = document.querySelector("link[rel='icon']");

  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  link.href = "favicon.ico";
}